import service from "services/maintenance/signatoryService";
import personResource from "features/maintenance/resources/personResource";
import costCenterResource from "features/maintenance/resources/costCenterResource";
import { PersonalInjuryOutlined } from "@mui/icons-material";
import MAINTENANCE_STORE_SELECTORS from "features/maintenance/dataStore/selectors";

const loanTypeResource = {
    title: "Signatories",
    singular: "Signatory",
    displayField: "description",
    service: service,
    pageIcon: PersonalInjuryOutlined,
    setter: MAINTENANCE_STORE_SELECTORS.SIGNATORY,

    columns: [
        {
            field: "documents",
            header: "Documents",
            width: "15%"
        },
        {
            field: "primaryPersonName",
            header: "Signatory"
        },
        {
            field: "secondaryPersonName",
            header: "Secondary"
        },
        {
            field: "costCenterName",
            header: "Division/Unit"
        },
        {
            field: "createdByName",
            header: "Created By",
            width: "10%"
        },
        {
            field: "updatedByName",
            header: "Updated By",
            width: "10%"
        }
    ],
    fields: [
        {
            name: "documents",
            label: "Documents",
            type: "select",
            required: true,
            //unique: true,
            options: [
                { value: "1", label: "Daily Time Record" },
                { value: "2", label: "Accomplishment Report" },
                { value: "3", label: "Gate Pass" },
                { value: "4", label: "Application for Leave" }
            ]
        },
        {
            name: "primaryPersonName",
            label: "Primary",
            type: "lookup",
            required: true,
            resource: personResource,
            lookupField: "fullName",
            sourceDataField: "id",
            targetDataField: "primaryEmployeeId"
        },
        {
            name: "primaryPersonName",
            label: "Secondary",
            type: "lookup",
            // required: true,
            resource: personResource,
            lookupField: "fullName",
            sourceDataField: "id",
            targetDataField: "secondaryEmployeeId"
        },
        {
            name: "costCenterName",
            label: "Division/Unit",
            type: "lookup",
            required: true,
            resource: costCenterResource,
            lookupField: "description",
            sourceDataField: "id",
            targetDataField: "costCenterId"
        },
        {
            name: "others",
            label: "Other Temporary Signatories",
            type: "text"
        }
    ],
    searchFields: ["description"]
};

export default loanTypeResource;
